import { render } from "./Goals.vue?vue&type=template&id=7f6078e0&scoped=true"
import script from "./Goals.vue?vue&type=script&lang=js"
export * from "./Goals.vue?vue&type=script&lang=js"

import "./Goals.vue?vue&type=style&index=0&id=7f6078e0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7f6078e0"

export default script